// extracted by mini-css-extract-plugin
module.exports = {"tabletMiddle":"(max-width: 768px)","root":"root-2aVJS","payload":"payload-1v4-i","icon":"icon-2qqZY","review":"review-3AsXN","buttons":"buttons-2lR7V","account":"account-1iXut"};